





















import Vue from "vue";
import Fieldset, { Field } from "@/components/ui/Fieldset.vue";
import FieldCollapse, {
  CollapseField,
} from "@/components/ui/FieldCollapse.vue";

export interface FileInfo {
  file: string;
  url: string;
}

export default Vue.extend({
  name: "FieldFiles",
  components: { Fieldset, FieldCollapse },
  props: {
    title: {
      type: String,
      default: "",
    },
    data: {
      type: Array as () => FileInfo[],
      required: true,
    },
    invert: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    collapsedField(): CollapseField[] {
      return [
        { title: this.title, fields: [this.fileField] },
      ] as CollapseField[];
    },
  },
  data: function () {
    return {
      fileField: { key: "files" } as Field,
    };
  },
});
